import React from 'react'

import useDeepEqualsMemoValue from 'v2/ui/utils/useDeepEqualsMemoValue'

import {
    AdvancedFiltersContext,
    AdvancedFiltersContextValue,
} from './hooks/useAdvancedFiltersContext'
import { LabelledField } from './types'

type AdvancedFiltersContextProviderProps = Omit<
    AdvancedFiltersContextValue,
    'recommendedFields'
> & {
    children: React.ReactNode
    recommendedFieldSids?: string[]
}

export const AdvancedFiltersContextProvider: React.FC<AdvancedFiltersContextProviderProps> = ({
    children,
    fields,
    recommendedFieldSids = [],
    ...props
}) => {
    const recommendedFieldsSidsSet = new Set(recommendedFieldSids)
    const recommendedFields: LabelledField[] = fields.filter((field) =>
        recommendedFieldsSidsSet.has(field.field._sid)
    )

    const value: AdvancedFiltersContextValue = useDeepEqualsMemoValue({
        fields,
        recommendedFields,
        ...props,
    })

    return (
        <AdvancedFiltersContext.Provider value={value}>{children}</AdvancedFiltersContext.Provider>
    )
}
